import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { ContentProvider } from "@/context/ContentContext";
import { AuthProvider } from "@/context/AuthContext";

import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import Seo from "@/components/site/Seo";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProjectsPage from "@/pages/ProjectsPage";
import StandardsPage from "@/pages/StandardsPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

function PublicLayout({ children }) {
  return (
    <div className="App bg-[#f9f8f6] text-[#1a1a1a]">
      <Seo />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function AdminLayout({ children }) {
  return <div className="min-h-screen bg-[#f9f8f6] text-[#1a1a1a]">{children}</div>;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <AdminLayout>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AdminLayout>
    );
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/autorius" element={<AboutPage />} />
        <Route path="/projektai" element={<ProjectsPage />} />
        <Route path="/standartas" element={<StandardsPage />} />
        <Route path="/kainos" element={<PricingPage />} />
        <Route path="/kontaktai" element={<ContactPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ContentProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Shell />
            <Toaster
              position="bottom-center"
              toastOptions={{
                style: {
                  background: "#1a1a1a",
                  color: "#f9f8f6",
                  border: "1px solid #1a1a1a",
                  borderRadius: 0,
                  fontFamily: "Manrope, sans-serif",
                  letterSpacing: "0.04em",
                },
              }}
            />
          </BrowserRouter>
        </AuthProvider>
      </ContentProvider>
    </HelmetProvider>
  );
}

export default App;
